module.exports = __webpack_public_path__ + "static/media/rudder.f60c6c8f.svg";